module.exports = __webpack_public_path__ + "static/img/Logotipo_Positivo_Vertical.7bca571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paginaoficial/Logotipo_Positivo_Vertical.jpg
// module id = uI3Y
// module chunks = 2